import { SET_WEBSITE_PASSWORD_VALIDITY } from '../actionTypes';

export const setIsValidPassword = (isPasswordValid) => {
  return async (dispatch) => {
    dispatch({
      type: SET_WEBSITE_PASSWORD_VALIDITY,
      payload: isPasswordValid
    });
  };
};
